import { put, take, fork, call, select, all } from "redux-saga/effects";
import { ClaimAction, ClaimScope } from "./types";
import {
  enableScopeLoading,
  disableScopeLoading,
} from "../scope-loading/actions";
import { ScopeErrorAction } from "../scope-error/types";
import {
  makeHTMLContentForTicket,
  mapApiClaimData,
  nextStepRedirect,
} from "./helpers";
import * as API from "../../service/api";
import { updateClaimState } from "./actions";
import axios from "axios";
import { RootState } from "../root-reducer";
import { deepAssign, getNestedValue } from "../../helper";

function* removeClaimImageFlow() {
  while (true) {
    const { payload } = yield take(ClaimAction.REMOVE_CLAIM_IMAGE);
    yield put(enableScopeLoading(ClaimScope));
    try {
      const { fileName, storeKeyName } = payload;
      const claimId = yield select((state: RootState) => state.claim.id);
      yield call(API.fileClaim.deleteClaimImage, claimId, fileName);
      const claim = yield select((state: RootState) => state?.claim || {});
      const oldValue = getNestedValue(claim, storeKeyName);
      const updatedStore = deepAssign(
        storeKeyName,
        oldValue.filter((fileUrl) => !fileUrl.includes(fileName)),
        structuredClone(claim)
      );
      yield put(updateClaimState(updatedStore));
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: ClaimScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(ClaimScope));
    }
  }
}

function* uploadClaimImageFlow() {
  while (true) {
    const { payload = {} } = yield take(ClaimAction.UPLOAD_CLAIM_IMAGE);
    yield put(enableScopeLoading(ClaimScope));
    try {
      const { files, isMultiple, storeKeyName } = payload;
      const claim = yield select((state: RootState) => state?.claim || {});
      const claimId = yield select((state: RootState) => state.claim.id);
      if (!isMultiple) {
        const url = getNestedValue(claim, storeKeyName);
        if (url) {
          const fileName = url?.split("/")?.pop();
          yield call(API.fileClaim.deleteClaimImage, claimId, fileName);
        }
      }
      const uploadedUrlList: string[] = yield all(
        files.map(function* (file) {
          const uploadURL = yield call(
            API.fileClaim.getPresignedURL,
            claimId,
            file?.type
          );
          yield axios.put(uploadURL, file, {
            headers: {
              "Content-Type": file.type,
            },
          });
          const urlObj = new URL(uploadURL);
          urlObj.search = "";
          return urlObj.toString();
        })
      );
      const oldValues = getNestedValue(claim, storeKeyName);
      const updtedStore = deepAssign(
        storeKeyName,
        isMultiple ? oldValues.concat(uploadedUrlList) : uploadedUrlList[0],
        structuredClone(claim)
      );
      yield put(updateClaimState(updtedStore));
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: ClaimScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(ClaimScope));
    }
  }
}

function* submitClaimFlow() {
  while (true) {
    yield take(ClaimAction.SUBMIT_CLAIM);
    yield put(enableScopeLoading(ClaimScope));
    try {
      const claimState = yield select((state) => state.claim);
      // const claimName = yield select((state) => state?.claim.name || "");
      // yield call(API.fileClaim.upsertClaim, body);
      const data = yield call(
        API.fileClaim.upsertClaim,
        mapApiClaimData(claimState)
      );
      console.log("data:", data);
      if (data?.status?.toLowerCase() === "success") {
        const claimId = data?.details?.id;
        const claimData = yield call(API.fileClaim.getClaim, claimId);
        const claimName = claimData?.Name;
        yield put(
          updateClaimState({
            name: claimName,
          })
        );
        const email = yield select(
          (state: RootState) =>
            state?.claim?.customerInfo?.email || "no@email.com"
        );
        yield call(API.fileClaim.createDeskTicket, {
          claimId,
          contact_email: email,
          subject: `Review New Mattress Claim: ${claimName}`,
          description: makeHTMLContentForTicket(claimState, claimName),
        });
      }
      nextStepRedirect(6);
    } catch (error) {
      console.log("error:", error);
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: ClaimScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(ClaimScope));
    }
  }
}

export default function* claimSaga() {
  yield fork(submitClaimFlow);
  yield fork(removeClaimImageFlow);
  yield fork(uploadClaimImageFlow);
}
